import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@xpo-ltl/ngx-ltl-core/button';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import * as i4 from '@angular/material/button';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { XpoCardModule } from '@xpo-ltl/ngx-ltl-core/card';

function XpoConfirmDialogWindow_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.data.confirmConfig.icon);
} }
function XpoConfirmDialogWindow_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function XpoConfirmDialogWindow_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.cancelAction(); });
    i0.ɵɵtext(1, "Cancel");
    i0.ɵɵelementEnd();
} }
const _c0 = ["*"];
class XpoConfirmDialogWindow {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.config = {};
        this.config.confirmButtonText = data.confirmConfig.confirmButtonText || 'Confirm';
        this.config.confirmButtonColor = data.confirmConfig.confirmButtonColor || 'primary';
        this.config.rejectButtonText = data.confirmConfig.rejectButtonText || 'Cancel';
        this.config.rejectButtonColor = data.confirmConfig.rejectButtonColor || 'accent';
        this.config.showCancelButton = false;
    }
    confirmAction() {
        this.dialogRef.close(true);
    }
    cancelAction() {
        this.dialogRef.close(false);
    }
}
XpoConfirmDialogWindow.ɵfac = function XpoConfirmDialogWindow_Factory(t) { return new (t || XpoConfirmDialogWindow)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
XpoConfirmDialogWindow.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConfirmDialogWindow, selectors: [["xpo-confirm-dialog-window"]], hostAttrs: [1, "xpo-ConfirmDialog"], decls: 11, vars: 6, consts: [["mat-dialog-title", "", 1, "xpo-ConfirmDialog-header"], [4, "ngIf"], ["mat-dialog-content", "", 1, "xpo-ConfirmDialog-content", 3, "innerHTML"], ["mat-dialog-actions", ""], ["mat-flat-button", "", "xpoLargeButton", "", "xpoButton", "", 3, "click"], ["mat-stroked-button", "", "xpoLargeButton", "", "xpoButton", "", 3, "click"], ["mat-stroked-button", "", "xpoLargeButton", "", "xpoButton", "", 3, "click", 4, "ngIf"]], template: function XpoConfirmDialogWindow_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h1", 0);
        i0.ɵɵtemplate(1, XpoConfirmDialogWindow_mat_icon_1_Template, 2, 1, "mat-icon", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "xpo-button-group");
        i0.ɵɵelementStart(6, "button", 4);
        i0.ɵɵlistener("click", function XpoConfirmDialogWindow_Template_button_click_6_listener() { return ctx.confirmAction(); });
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "button", 5);
        i0.ɵɵlistener("click", function XpoConfirmDialogWindow_Template_button_click_8_listener() { return ctx.cancelAction(); });
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, XpoConfirmDialogWindow_button_10_Template, 2, 0, "button", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data == null ? null : ctx.data.confirmConfig == null ? null : ctx.data.confirmConfig.icon);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.data == null ? null : ctx.data.title, "\n");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", ctx.data == null ? null : ctx.data.message, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.config == null ? null : ctx.config.confirmButtonText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.config == null ? null : ctx.config.rejectButtonText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data == null ? null : ctx.data.confirmConfig == null ? null : ctx.data.confirmConfig.showCancelButton);
    } }, directives: [i1.MatDialogTitle, i2.NgIf, i1.MatDialogContent, i1.MatDialogActions, i3.XpoButtonGroup, i4.MatButton, i3.XpoLargeButton, i3.XpoButton, i5.MatIcon], styles: [".flex--stretch{flex:1}.mat-dialog-container .xpo-ConfirmDialog h1.mat-dialog-title.xpo-ConfirmDialog-header{align-items:flex-start;grid-gap:8px;gap:8px;justify-content:left}.mat-dialog-container .xpo-ConfirmDialog h1.mat-dialog-title.xpo-ConfirmDialog-header .mat-icon{color:#4a4a4a}mat-dialog-container.mat-dialog-container .mat-dialog-container .xpo-ConfirmDialog-content.mat-dialog-content{font-size:1.143rem}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConfirmDialogWindow, [{
        type: Component,
        args: [{
                selector: 'xpo-confirm-dialog-window',
                templateUrl: './confirm-dialog.html',
                styleUrls: ['./confirm-dialog.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-ConfirmDialog',
                },
            }]
    }], function () { return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();
class XpoConfirmDialog {
    constructor(dialog) {
        this.dialog = dialog;
    }
    // TODO: Change the order of the parameters, decide when is the best time to do it,
    // since this will be a breaking change
    confirm(message, title = 'Confirmation', confirmConfig = {}) {
        const dialogRef = this.dialog.open(XpoConfirmDialogWindow, {
            width: confirmConfig.width || '600px',
            disableClose: true,
            data: { message: message, title: title, confirmConfig: confirmConfig },
        });
        return new Observable((observer) => {
            dialogRef.afterClosed().subscribe((result) => {
                observer.next(result);
                observer.complete();
            });
        });
    }
}
XpoConfirmDialog.ɵfac = function XpoConfirmDialog_Factory(t) { return new (t || XpoConfirmDialog)(i0.ɵɵdirectiveInject(i1.MatDialog)); };
XpoConfirmDialog.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConfirmDialog, selectors: [["xpo-confirm-dialog"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function XpoConfirmDialog_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConfirmDialog, [{
        type: Component,
        args: [{
                selector: 'xpo-confirm-dialog',
                template: '<ng-content></ng-content>',
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return [{ type: i1.MatDialog }]; }, null); })();

class XpoConfirmDialogModule {
}
XpoConfirmDialogModule.ɵfac = function XpoConfirmDialogModule_Factory(t) { return new (t || XpoConfirmDialogModule)(); };
XpoConfirmDialogModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoConfirmDialogModule });
XpoConfirmDialogModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [XpoConfirmDialog], imports: [[CommonModule, MatDialogModule, XpoCardModule, XpoButtonModule, MatIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConfirmDialogModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoConfirmDialog, XpoConfirmDialogWindow],
                imports: [CommonModule, MatDialogModule, XpoCardModule, XpoButtonModule, MatIconModule],
                exports: [XpoConfirmDialogWindow],
                providers: [XpoConfirmDialog],
                entryComponents: [XpoConfirmDialogWindow],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoConfirmDialogModule, { declarations: [XpoConfirmDialog, XpoConfirmDialogWindow], imports: [CommonModule, MatDialogModule, XpoCardModule, XpoButtonModule, MatIconModule], exports: [XpoConfirmDialogWindow] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoConfirmDialog, XpoConfirmDialogModule, XpoConfirmDialogWindow };
